import React, { useState } from 'react';
import { CalendarIcon, FilterXIcon, TrophyIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const MatchesCalendar = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [filters, setFilters] = useState({
    league: '',
    season: '',
    phase: '',
    team: ''
  });
  // Reuse the same filter options
  const leagues = ['NBA', 'Euroleague', 'Liga ACB', 'LNB Pro A'];
  const seasons = ['2023-2024', '2022-2023', '2021-2022'];
  const phases = ['Regular Season', 'Playoffs', 'Play-In'];
  const teams = ['New York Knicks', 'Los Angeles Lakers', 'Boston Celtics'];
  // Sample dates with matches (would come from API)
  const datesWithMatches = [new Date(2024, 2, 15), new Date(2024, 2, 20), new Date(2024, 2, 25), new Date(2024, 3, 1)];
  // Sample matches data
  const matches = [{
    id: 1,
    homeTeam: {
      name: 'New York Knicks',
      logo: 'https://content.sportslogos.net/logos/6/216/thumbs/2nn48xofg0hms8k326cqdmuis.gif',
      score: 112
    },
    awayTeam: {
      name: 'Los Angeles Lakers',
      logo: 'https://content.sportslogos.net/logos/6/237/thumbs/uig7aiht8jnpl1szbi57zzlsh.gif',
      score: 108
    },
    status: 'Final',
    league: 'NBA',
    phase: 'Regular Season'
  }, {
    id: 2,
    homeTeam: {
      name: 'Boston Celtics',
      logo: 'https://content.sportslogos.net/logos/6/213/thumbs/slhg02hbef3j1ov4lsnwyol5o.gif'
    },
    awayTeam: {
      name: 'Miami Heat',
      logo: 'https://content.sportslogos.net/logos/6/214/thumbs/burm5gh2wvjti3xhei5h16k8e.gif'
    },
    status: 'Scheduled',
    time: '20:00',
    league: 'NBA',
    phase: 'Regular Season'
  }];
  const resetFilters = () => {
    setFilters({
      league: '',
      season: '',
      phase: '',
      team: ''
    });
  };
  const handleMatchClick = (matchId: number) => {
    navigate(`/matches/${matchId}`);
  };
  const isMatchDay = (date: Date) => {
    return datesWithMatches.some(matchDate => matchDate.toDateString() === date.toDateString());
  };
  return <div className="w-full max-w-7xl mx-auto pb-12" data-id="element-149" data-mp="1n6956thbdut6">
      {/* Filters */}
      <div className="bg-white rounded-lg shadow-sm p-4 mb-6" data-id="element-150" data-mp="1n8d6d3ntwfpr">
        <h2 className="text-xl font-bold mb-4" data-id="element-151" data-mp="1r6axwd52ndwb">Matches Calendar</h2>
        <div className="flex items-center gap-4" data-id="element-152" data-mp="uhv76dq86yhm">
          <select value={filters.league} onChange={e => setFilters({
          ...filters,
          league: e.target.value
        })} className="rounded-md border-gray-300 text-sm" data-id="element-153" data-mp="ujel3xoesxg8">
            <option value="" data-id="element-154" data-mp="18io0ww8pdpjo">League</option>
            {leagues.map(league => <option key={league} value={league} data-id="element-155" data-mp="2ew58sp5tysdx">
                {league}
              </option>)}
          </select>
          <select value={filters.season} onChange={e => setFilters({
          ...filters,
          season: e.target.value
        })} className="rounded-md border-gray-300 text-sm" data-id="element-156" data-mp="2juf5j477e11n">
            <option value="" data-id="element-157" data-mp="2k8u4bpqqz001">Season</option>
            {seasons.map(season => <option key={season} value={season} data-id="element-158" data-mp="2g7qr7b033i2i">
                {season}
              </option>)}
          </select>
          <select value={filters.phase} onChange={e => setFilters({
          ...filters,
          phase: e.target.value
        })} className="rounded-md border-gray-300 text-sm" data-id="element-159" data-mp="2bb06ubh8y0ba">
            <option value="" data-id="element-160" data-mp="1xb8yaq9i1c4o">Phase</option>
            {phases.map(phase => <option key={phase} value={phase} data-id="element-161" data-mp="3voiroi7wy11d">
                {phase}
              </option>)}
          </select>
          <select value={filters.team} onChange={e => setFilters({
          ...filters,
          team: e.target.value
        })} className="rounded-md border-gray-300 text-sm" data-id="element-162" data-mp="3rogrkdhttfo7">
            <option value="" data-id="element-163" data-mp="3ppfdcaagr8eq">Team</option>
            {teams.map(team => <option key={team} value={team} data-id="element-164" data-mp="3triyjqmxprd7">
                {team}
              </option>)}
          </select>
          <button onClick={resetFilters} className="ml-auto flex items-center px-3 py-2 text-sm font-medium text-gray-700 hover:text-gray-900" data-id="element-165" data-mp="3fzvs4xza32gp">
            <FilterXIcon className="w-4 h-4 mr-2" data-id="element-166" data-mp="363982bes0ffq" />
            Reset Filters
          </button>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-6" data-id="element-167" data-mp="3b2cfu3m54zre">
        {/* Calendar */}
        <div className="col-span-4" data-id="element-168" data-mp="2x19szonbnlff">
          <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-169" data-mp="2x2baobyuf664">
            <div className="flex items-center justify-between mb-4" data-id="element-170" data-mp="3215thdwt8uq8">
              <button className="p-2 hover:bg-gray-100 rounded-md" data-id="element-171" data-mp="2if2xj5lz4qri">
                <CalendarIcon className="w-5 h-5 text-gray-600" data-id="element-172" data-mp="2ifcpuzuhra0d" />
              </button>
              <h3 className="font-semibold" data-id="element-173" data-mp="2dhkkp44u5re8">
                {selectedDate.toLocaleDateString('default', {
                month: 'long',
                year: 'numeric'
              })}
              </h3>
              <div className="flex gap-1" data-id="element-174" data-mp="2ncw25u7mpcpo">
                <button className="p-2 hover:bg-gray-100 rounded-md" onClick={() => setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth() - 1, 1))} data-id="element-175" data-mp="31df6orcvy0n3">
                  ←
                </button>
                <button className="p-2 hover:bg-gray-100 rounded-md" onClick={() => setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1))} data-id="element-176" data-mp="3k4pu2yjejva8">
                  →
                </button>
              </div>
            </div>
            <div className="grid grid-cols-7 gap-1 mb-2" data-id="element-177" data-mp="2qkwyk1b39iad">
              {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => <div key={day} className="text-center text-sm font-medium text-gray-600" data-id="element-178" data-mp="30hjfwg47hr7n">
                  {day}
                </div>)}
            </div>
            <div className="grid grid-cols-7 gap-1" data-id="element-179" data-mp="39iq0b09z7m66">
              {Array.from({
              length: new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0).getDate()
            }).map((_, i) => {
              const date = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), i + 1);
              const hasMatches = isMatchDay(date);
              return <button key={i} onClick={() => setSelectedDate(date)} className={`p-2 rounded-md text-sm ${date.toDateString() === selectedDate.toDateString() ? 'bg-blue-500 text-white' : hasMatches ? 'bg-blue-50 text-blue-600 font-medium' : 'hover:bg-gray-100'}`} data-id="element-180" data-mp="xv4ee7wfpcwy" data-mpi={i}>
                    {i + 1}
                  </button>;
            })}
            </div>
          </div>
        </div>
        {/* Matches List */}
        <div className="col-span-8" data-id="element-181" data-mp="1clv5teu469zj">
          <div className="bg-white rounded-lg shadow-sm" data-id="element-182" data-mp="6480d3yn1283">
            <div className="p-4 border-b" data-id="element-183" data-mp="61ltl6jkmqqx">
              <h3 className="font-semibold" data-id="element-184" data-mp="142fc6mvidyz">
                {selectedDate.toLocaleDateString('default', {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              })}
              </h3>
            </div>
            <div className="divide-y" data-id="element-185" data-mp="1r9701lko24ww">
              {matches.map(match => <div key={match.id} className="p-4 hover:bg-gray-50 cursor-pointer" onClick={() => handleMatchClick(match.id)} data-id="element-186" data-mp="1w7qmdn369ips">
                  <div className="flex items-center justify-between" data-id="element-187" data-mp="2ow62ye1yc938">
                    <div className="flex items-center gap-4 flex-1" data-id="element-188" data-mp="2oyiheh8i41bj">
                      <img src={match.homeTeam.logo} alt={match.homeTeam.name} className="w-8 h-8 object-contain" data-id="element-189" data-mp="2a6qdd1e5q9p4" />
                      <span className="font-medium" data-id="element-190" data-mp="32uma263q81lw">{match.homeTeam.name}</span>
                    </div>
                    <div className="w-24 text-center" data-id="element-191" data-mp="37o8bf24fwj2e">
                      {match.status === 'Final' ? <div data-id="element-192" data-mp="w5tzazi0179o">
                          <div className="font-bold" data-id="element-193" data-mp="r93jmda3wdos">
                            {match.homeTeam.score} - {match.awayTeam.score}
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-194" data-mp="14zgq0b7cnkc0">Final</div>
                        </div> : <div data-id="element-195" data-mp="d8ssra8sqz3m">
                          <div className="font-medium" data-id="element-196" data-mp="da3wxb65m8v9">{match.time}</div>
                          <div className="text-xs text-gray-500" data-id="element-197" data-mp="8a9617mdpja7">Scheduled</div>
                        </div>}
                    </div>
                    <div className="flex items-center gap-4 flex-1 justify-end" data-id="element-198" data-mp="mb2422bw2wi2">
                      <span className="font-medium" data-id="element-199" data-mp="h9wa616ht36y">{match.awayTeam.name}</span>
                      <img src={match.awayTeam.logo} alt={match.awayTeam.name} className="w-8 h-8 object-contain" data-id="element-200" data-mp="1xo4fyk31mxvw" />
                    </div>
                  </div>
                  <div className="mt-2 flex items-center gap-2 text-sm text-gray-500" data-id="element-201" data-mp="svg4jnbdxdh5">
                    <TrophyIcon className="w-4 h-4" data-id="element-202" data-mp="nwlm4mhbxqxk" />
                    <span data-id="element-203" data-mp="j2qv0xzea9og">{match.league}</span>
                    <span data-id="element-204" data-mp="j1pmb05upz9w">•</span>
                    <span data-id="element-205" data-mp="f2qjpm7leelm">{match.phase}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default MatchesCalendar;